import React from 'react';
import { Check, ChevronDown } from '@good/icons';

import { useRichTextEditor } from '../rich-text-editor-context';
import { Button, Menu, rem, Text } from '@good/ui/core';

const fontSizeOptions = [10, 12, 14, 16, 18, 20, 24, 28, 32, 36, 48, 72];

export const FontSizeDropdown = () => {
  const { editor, disabled } = useRichTextEditor();

  const getCurrentFontSize = () => {
    // Try to get the font size from the current selection
    const { fontSize } = editor.getAttributes('textStyle');
    if (fontSize) {
      return Number.parseInt(fontSize.replace('px', ''), 10);
    }
    return 14; // default
  };

  const activeFontSize = getCurrentFontSize();
  const isDisabled = disabled;

  const onChange = (fontSize: number) => {
    if (!editor || editor.isDestroyed) return;

    try {
      // Apply font size to selected text or set for future typing
      editor
        .chain()
        .focus()
        .setMark('textStyle', { fontSize: `${fontSize}px` })
        .run();
    } catch (error) {
      console.error('Error setting font size:', error);
    }
  };

  return (
    <Menu shadow='md' width={200} position='bottom-start'>
      <Menu.Target>
        <Button
          size='xs'
          variant='outline'
          color='neutral'
          aria-label='font-size'
          disabled={isDisabled}
          leftSection={
            <Text size='xs' fw={700} w={rem(30)} pl={rem(8)}>
              {activeFontSize}
            </Text>
          }
          rightSection={
            <Text size='xs' c='var(--brand-body-dark-2)' w={rem(30)} pr={rem(8)}>
              <ChevronDown />
            </Text>
          }
          w={80}
        />
      </Menu.Target>
      <Menu.Dropdown>
        {fontSizeOptions.map((fontSize) => (
          <Menu.Item
            key={fontSize}
            onClick={() => onChange(fontSize)}
            leftSection={
              activeFontSize === fontSize ? (
                <Text size='xs' c='var(--brand-body-dark-2)'>
                  <Check />
                </Text>
              ) : undefined
            }
          >
            {fontSize}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};
